export default "__VITE_ASSET__jjqImd_V__"